module.exports = __webpack_public_path__ + "static/img/demo-card-squirrel.fa3ddfc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/demo-card-squirrel.png
// module id = 35jG
// module chunks = 1